import {
  CircularProgress,
  InputAdornment,
  Popover,
  TextField,
} from "@mui/material";
import { FaRegUserCircle } from "react-icons/fa";
import { Search } from "@mui/icons-material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState, useRef } from "react";
import { FiLogOut } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { GlobalStateContext } from "../context/GlobalStateContext";
import {
  getCustomerAddress,
  getListCartInfo,
} from "../../services/purchaseApi";
import {
  deleteSearchHistory,
  getSearchHistory,
} from "../../services/searchApi";
import { logout } from "../../redux/features/auth/authSlice";
import { HiOutlineBell, HiOutlineShoppingCart } from "react-icons/hi2";
import { FiSearch } from "react-icons/fi";
import useScrollDetection from "../../hooks/useScrollDetection";
import { LuArrowLeft, LuUserCog } from "react-icons/lu";
import useDebounce from "../../hooks/useDebounce";
import SwipeSearchMobile from "../swipeComp/SwipeSearchMobile";
import { listProduct } from "../../services/productApi";
import { getLabelConfig } from "../../config/labelConfig";
import SearchModal from "../modalComp/SearchModal";
import { readSafeStorage } from "../../utils/localStorageHelper";
import { IoArrowBack } from "react-icons/io5";

const linkBaseClass = "relative font-medium transition-colors group";
const underlineClass =
  "after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-300 group-hover:after:w-full";

const HeaderPurchase = ({
  isSearch,
  isNotSearchIcon,
  isNotCartIcon,
  logo,
  back,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { isLogin, setIsLogin, setRecipeId } = useContext(GlobalStateContext);
  const name = readSafeStorage("fullname", "Pengguna");
  const email = readSafeStorage("email", "-");
  const profileImage = readSafeStorage("profile_image", "");
  const addressFromLocal = readSafeStorage(
    "address",
    "Tidak ada alamat terdaftar",
  );
  var popup = document.getElementById("popup-search");
  const label = getLabelConfig();
  const { pathname } = useLocation();

  const isScrolled = useScrollDetection(5);
  const [search, setSearch] = useState("");
  const [anchorElProfile, setAnchorElProfile] = useState(null);
  const [open, setOpen] = useState(false);
  const [companyId, setCompanyId] = useState(
    id ? id : localStorage.getItem("companyId") || "",
  );
  const [isMobileView, setIsMobileView] = useState(false);
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const [showSearch, setShowSearch] = useState(isSearch);
  const [dataSearch, setDataSearch] = useState(null);
  const [openSuggest, setOpenSuggest] = useState(false);
  const outletLogo = readSafeStorage("outlet_logo", label.logo);

  const debounceSearch = useDebounce(search, 1000);
  const searchInputRef = useRef(null);
  const searchModalRef = useRef(null);

  useEffect(() => {
    if (isScrolled && !isSearch) {
      setOpenSearchModal(false);
      setShowSearch(false);
    }
  }, [isScrolled]);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  document.onmousedown = (e) => {
    if (popup && open) {
      var bound = popup.getBoundingClientRect();

      e.screenX < bound.x ||
      e.screenX > bound.x + bound.width ||
      e.screenY > bound.y + bound.height + 120
        ? setOpen(false)
        : setOpen(true);
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    setIsLogin(false);
    navigate("/purchase");
  };

  const { data: countCart, isLoading: isCountCartLoading } = useQuery({
    queryKey: ["count-cart"],
    queryFn: () => getListCartInfo(),
    refetchOnWindowFocus: true,
    staleTime: 0,
  });

  const { mutate: mutateList, isPending: isListLoading } = useMutation({
    mutationFn: listProduct,
    onSuccess: (data) => {
      // if (!data) setHasMore(false);
      if (data && data !== undefined) {
        setDataSearch(
          data.map((data) => ({
            ...data,
            isLoading: false,
          })),
        );
      }
    },
  });

  useEffect(() => {
    if (debounceSearch && debounceSearch !== "") {
      const body = {
        limit: 5,
        offset: 1,
        keyword: debounceSearch,
        company_id: Number(companyId),
      };
      mutateList(body);
    }
  }, [debounceSearch]);

  const {
    data: dataHistorySearch,
    isFetching: isFetchingHistorySearch,
    error: errorHistorySearch,
    refetch: refetchHistorySearch,
  } = useQuery({
    queryKey: ["history-search", isLogin],
    queryFn: () => getSearchHistory(),
    enabled: isLogin,
    refetchOnWindowFocus: false,
  });

  const { mutate: mutateDeleteHistory } = useMutation({
    mutationFn: deleteSearchHistory,
    onSuccess: () => {
      refetchHistorySearch();
    },
  });

  const {
    data: dataAddress,
    isFetching: isFetchingAddress,
    refetch: refetchAddress,
  } = useQuery({
    queryKey: ["customer-address", Boolean(anchorElProfile)],
    queryFn: () => getCustomerAddress(),
    enabled: isLogin === true,
    keepPreviousData: false,
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openSuggest &&
        searchModalRef.current &&
        !searchModalRef.current.contains(event.target) &&
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target)
      ) {
        setOpenSuggest(false);
        setSearch("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openSuggest]);

  // listen for changes to companyId in localStorage
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === "companyId") {
        setCompanyId(e.newValue || "");
      }
    };

    window.addEventListener("storage", handleStorage);

    // observe company id
    const observer = new MutationObserver(() => {
      setCompanyId(localStorage.getItem("companyId") || "");
    });
    observer.observe(document, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    return () => {
      window.removeEventListener("storage", handleStorage);
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === "companyId") {
        setCompanyId(e.newValue || "");
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return (
    <>
      {!isMobileView && (
        <nav className="sticky top-0 z-50 shadow-sm bg-white">
          <div className="max-w-7xl lg:px-8 xl:px-0 mx-auto">
            <div className="flex items-center justify-between py-2 sm:py-1 px-4 sm:px-6 lg:px-0 min-h-[64px]">
              <a
                href="/"
                className="flex items-center h-10 max-w-[240px] w-auto shrink-0"
              >
                <img
                  src={outletLogo}
                  className="h-full w-auto max-w-full object-contain"
                  alt="Outlet Logo"
                />
              </a>

              <div className="hidden lg:flex items-center gap-6 xl:gap-8 text-slate-600 flex-1 justify-end">
                <a
                  href="/purchase/transaction-list"
                  className={`relative ${linkBaseClass} ${
                    pathname.includes("/purchase/transaction-list")
                      ? "text-primary"
                      : "text-gray-700 hover:text-primary"
                  } ${underlineClass} ${
                    pathname.includes("/purchase/transaction-list")
                      ? "after:w-full"
                      : "after:w-0"
                  }`}
                >
                  <p className="text-base">Pesanan</p>
                </a>
                <a
                  href="/purchase/cart-details"
                  className={`relative ${linkBaseClass} ${
                    pathname.includes("/purchase/cart-details")
                      ? "text-primary"
                      : "text-gray-700 hover:text-primary"
                  } ${underlineClass} ${
                    pathname.includes("/purchase/cart-details")
                      ? "after:w-full"
                      : "after:w-0"
                  }`}
                >
                  <p className="text-base">Keranjang</p>
                  {countCart && countCart.count > 0 && (
                    <div className="absolute -right-2 -top-2 text-sm h-4 w-4 rounded-full flex items-center justify-center bg-error text-white ">
                      {countCart && !isCountCartLoading ? countCart.count : "x"}
                    </div>
                  )}
                </a>
                <div className="w-full max-w-[400px] mx-4">
                  <div className="relative">
                    <form>
                      <div
                        ref={searchInputRef}
                        className="flex items-center gap-2 bg-slate-100 px-4 py-2 rounded-full cursor-text hover:bg-slate-200 transition-colors"
                        onClick={() => setOpenSuggest(true)}
                      >
                        <Search size={18} className="text-slate-600 shrink-0" />
                        <input
                          type="text"
                          placeholder="Cari produk..."
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          onFocus={() => setOpenSuggest(true)}
                          className="w-full bg-transparent outline-none text-sm lg:text-base"
                        />
                      </div>

                      <button type="submit" className="hidden">
                        Search
                      </button>
                    </form>

                    {openSuggest && (
                      <SearchModal
                        searchModalRef={searchModalRef}
                        search={search}
                        dataHistory={dataHistorySearch}
                        dataSearch={dataSearch}
                        loadingSearch={isListLoading}
                        mutateDelete={mutateDeleteHistory}
                        isLogin={isLogin}
                      />
                    )}
                  </div>
                </div>

                {isLogin ? (
                  <div className="">
                    {profileImage === "" ? (
                      <div
                        className="w-[44px] h-[44px] cursor-pointer text-secondary rounded-full border-2 border-secondary flex items-center justify-center hover:bg-secondaryActive transform duration-300"
                        onClick={(e) => setAnchorElProfile(e.currentTarget)}
                      >
                        <LuUserCog className="text-[24px]" />
                      </div>
                    ) : (
                      <img
                        src={profileImage}
                        alt="Profile IMG"
                        className="w-[44px] h-[44px] rounded-full object-cover cursor-pointer"
                        onClick={(e) => setAnchorElProfile(e.currentTarget)}
                      />
                    )}
                  </div>
                ) : (
                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      className="py-1.5 px-2 md:px-4 font-medium text-secondary border-2 border-secondary rounded-lg text-md md:text-base hover:bg-secondaryActive transform duration-300"
                      onClick={() => navigate("/register")}
                    >
                      Daftar
                    </button>
                    <button
                      type="button"
                      className="py-1.5 px-2 md:px-4 font-medium text-white bg-secondary border-2 border-secondary rounded-lg text-md md:text-base hover:bg-secondaryHover hover:border-secondaryHover transform duration-300"
                      onClick={() => navigate("/login")}
                    >
                      Masuk
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </nav>
      )}

      {isMobileView && (
        <div
          className={`bg-white fixed z-[9999] top-0 left-0 px-4 py-3 w-full flex items-center pt-4 transition-all duration-300 ${
            isScrolled && !openSearchModal ? "shadow-md rounded-b-3xl" : ""
          } ${showSearch ? "h-[120px]" : "h-[64px]"}`}
        >
          <div className="flex flex-col w-full gap-2">
            <div className="flex justify-between items-center w-full gap-2">
              {logo === "Logo" ? (
                <div
                  className="flex items-center h-10 max-w-[160px] w-auto shrink-0"
                  onClick={() => navigate("/")}
                >
                  <img
                    src={outletLogo}
                    className="h-full w-auto max-w-full object-contain"
                    alt="Outlet Logo"
                  />
                </div>
              ) : (
                <div className="w-full flex items-center gap-2 lg:hidden text-xl">
                  <div
                    onClick={() => navigate(back || "/")}
                    className="hover:bg-gray-200 rounded-full"
                  >
                    <IoArrowBack className="text-gray-500" size={20} />
                  </div>
                  <p className="font-semibold text-primary-700">
                    {logo}{" "}
                    {logo === "Keranjang Belanja" && (
                      <>
                        (
                        {countCart && !isCountCartLoading
                          ? countCart.count
                          : "0"}
                        )
                      </>
                    )}
                  </p>
                </div>
              )}
              <div className="flex gap-3 items-center">
                {!isNotSearchIcon &&
                  !showSearch &&
                  logo !== "Keranjang Belanja" && (
                    <IoIosSearch
                      size={28}
                      className="cursor-pointer hover:text-gray-700 text-gray-500"
                      onClick={() => setShowSearch(true)}
                    />
                  )}

                {logo !== "Keranjang Belanja" && (
                  <>
                    {/* <HiOutlineBell
                      size={28}
                      className="cursor-pointer hover:text-gray-700 text-gray-500"
                    /> */}
                    {!isNotCartIcon && (
                      <div className="relative">
                        <HiOutlineShoppingCart
                          size={28}
                          className="cursor-pointer hover:text-gray-700 text-gray-500"
                          onClick={() => {
                            navigate("/purchase/cart-details");
                          }}
                        />
                        {countCart && countCart.count > 0 && (
                          <div className="absolute -right-2 -top-2 text-sm h-4 w-4 rounded-full flex items-center justify-center bg-error text-white ">
                            {countCart && !isCountCartLoading
                              ? countCart.count
                              : "x"}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            {showSearch && (
              <div className="w-full flex items-center gap-1">
                {openSearchModal && (
                  <div
                    onClick={() => {
                      setOpenSearchModal(false);
                      setDataSearch(null);
                    }}
                    className="p-1 rounded-full"
                  >
                    <LuArrowLeft size={24} className="text-gray-500" />
                  </div>
                )}
                <TextField
                  autoComplete="off"
                  fullWidth
                  placeholder="Cari Produk"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setRecipeId(null);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment>
                        <FiSearch size={18} />
                      </InputAdornment>
                    ),
                    sx: {
                      backgroundColor: "#fff",
                      fontSize: "14px",
                      borderRadius: "32px",
                      height: "40px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#e5e7eb",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d1d5db",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#071b82",
                      },
                    },
                  }}
                  sx={{
                    backgroundColor: "#fff",
                    "& ::placeholder": { fontSize: "14px" },
                    fontSize: "14px",
                    height: "40px",
                    borderRadius: "32px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "32px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#071b82",
                      },
                    },
                  }}
                  onFocus={() => {
                    setOpenSearchModal(true);
                    if (isLogin) {
                      refetchHistorySearch();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && search !== "") {
                      navigate(`/purchase/search-product/${search}`);
                    }
                    setOpen(false);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}

      <SwipeSearchMobile
        open={openSearchModal}
        onClose={() => {
          setOpenSearchModal(false);
          setDataSearch(null);
          setSearch("");
        }}
        search={search}
        dataHistory={dataHistorySearch}
        dataSearch={dataSearch}
        loadingSearch={isListLoading}
        isLogin={isLogin}
        mutateDelete={mutateDeleteHistory}
      />

      <Popover
        open={Boolean(anchorElProfile)}
        anchorEl={anchorElProfile}
        onClose={() => setAnchorElProfile(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: "20px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 14px 40px rgba(15, 23, 42, 0.12)",
            overflow: "hidden",
          },
        }}
      >
        <div className="w-[360px] max-w-[90vw] p-5 bg-white">
          <div className="mb-4 rounded-2xl border border-slate-200 bg-gradient-to-r from-[#f8fbff] to-[#eef7ee] p-4 flex items-center gap-3">
            {profileImage ? (
              <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow-sm shrink-0">
                <img
                  src={profileImage}
                  alt="Profile IMG"
                  className="w-full h-full object-cover"
                />
              </div>
            ) : (
              <div className="w-12 h-12 rounded-full bg-secondary/15 text-secondary flex items-center justify-center border border-secondary/30 shrink-0">
                <FaRegUserCircle className="text-[26px]" />
              </div>
            )}

            <div className="min-w-0 flex-1">
              <p className="text-[15px] font-semibold text-slate-700 truncate">
                {name}
              </p>
              <p className="text-sm text-slate-500 truncate">{email}</p>
              {/* <p className="text-xs text-slate-400">Pengguna OLIN</p> */}
            </div>
          </div>

          <div className="mb-4 w-full rounded-2xl border border-slate-200 p-4 bg-slate-50">
            <p className="mb-2 font-semibold text-slate-700">
              Alamat Terdaftar
            </p>
            <div className="text-sm text-slate-600 leading-relaxed">
              {dataAddress &&
              !isFetchingAddress &&
              dataAddress.province !== "" ? (
                <p>
                  {dataAddress.detail_address} <br /> {dataAddress.subdistrict},{" "}
                  {dataAddress.district}, {dataAddress.city},{" "}
                  {dataAddress.province} {dataAddress.postal_code}
                </p>
              ) : isFetchingAddress ? (
                <CircularProgress size={20} />
              ) : (
                addressFromLocal
              )}
            </div>
          </div>

          <button
            type="button"
            className="rounded-xl p-2.5 border border-secondary bg-secondary text-white hover:bg-secondaryHover hover:border-secondaryHover w-full flex gap-2 items-center justify-center mb-2 transition-colors"
            onClick={() => navigate(`/location-address`)}
          >
            Edit Alamat
          </button>
          <button
            type="button"
            className="rounded-xl p-2.5 border border-slate-300 text-slate-700 hover:bg-slate-100 w-full flex gap-2 items-center justify-center transition-colors"
            onClick={handleLogout}
          >
            Keluar
            <FiLogOut />
          </button>
        </div>
      </Popover>
    </>
  );
};

export default HeaderPurchase;
